import { FunctionComponent, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles, mergeClasses } from '@griffel/react'
import { tokens } from '@fluentui/tokens'

const useClasses = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS
  },
  loading: {
    backgroundColor: tokens.colorNeutralBackground3
  }
})

/** Wrap this around each list and use @see ListItemPanel for each item in list. */
export const ListPanel: FunctionComponent<{ loading?: boolean, children?: React.ReactNode, className?: string }> = observer(({ loading, children, className }) => {
  const classes = useClasses()

  return (
    <div className={mergeClasses(classes.root, loading && classes.loading, className)}>
      {children}
    </div>
  )
})